import { ACTIONS } from '../Constants';

const initialState = {
    byId: {}
};

const badges = (state = initialState, action) => {
    let newById;
    let reduced;
    let badge;

    switch (action.type) {
        case ACTIONS.GET_MANY_BADGES: {
            const { badges = [] } = action.payload;

            reduced = badges.reduce((prev, badge) => {
                prev[badge._id] = badge;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_BADGE:
        case ACTIONS.PUT_BADGE_SUCCESS:
        case ACTIONS.POST_BADGE_SUCCESS: {
            ({ badge } = action.payload);
            newById = {
                ...state.byId,
                [badge._id]: badge
            };
            return {
                ...state,
                byId: newById
            };
        }

        default:
            return state;
    }
};

export default badges;
